import { render } from "./galerieImage.vue?vue&type=template&id=2c223f92"
import script from "./galerieImage.vue?vue&type=script&lang=ts"
export * from "./galerieImage.vue?vue&type=script&lang=ts"
script.render = render

export default script